import { render, staticRenderFns } from "./novelty.vue?vue&type=template&id=153f8970&scoped=true&"
import script from "./novelty.vue?vue&type=script&lang=js&"
export * from "./novelty.vue?vue&type=script&lang=js&"
import style0 from "./novelty.vue?vue&type=style&index=0&id=153f8970&lang=scss&scoped=true&"
import style1 from "./novelty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f8970",
  null
  
)

export default component.exports